import React, {
  ComponentPropsWithoutRef,
  ElementType,
  useEffect,
  useRef,
  useState,
} from 'react';
import classnames from 'classnames';

import Icon from '../icon/Icon';
import Responsive from '../responsive/Responsive';
import Button from '../controls/button/Button';
import Overlay from '../overlay/Overlay';
import AddPlaceCategories from '../add-place-categories/AddPlaceCategories';

import './AddPlaceControl.scss';

export interface AddPlaceControlProps
  extends ComponentPropsWithoutRef<ElementType> {
  className?: string;
}

const AddPlaceControl = ({ className }: AddPlaceControlProps) => {
  const [isOptionsShown, setIsOptionsShown] = useState(false);

  const addPlaceControlRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (isOptionsShown) {
      const handleClickOutsidePlaceCategories = ({ target }) => {
        if (
          addPlaceControlRef.current &&
          !addPlaceControlRef.current.contains(target)
        ) {
          setIsOptionsShown(false);
        }
      };
      document.addEventListener('click', handleClickOutsidePlaceCategories);

      return () =>
        document.removeEventListener(
          'click',
          handleClickOutsidePlaceCategories,
        );
    }
  }, [isOptionsShown]);

  return (
    <>
      <div
        ref={addPlaceControlRef}
        className={classnames('add-place-control', className)}
      >
        <Responsive mobile={false}>
          <Button
            className="add-place-control__open-menu-button"
            appearance="primary"
            onClick={() => setIsOptionsShown((val) => !val)}
          >
            <Icon
              className="add-place-control__open-menu-button-icon"
              name="plus-circle"
            />
            Contribute
          </Button>
          {isOptionsShown && (
            <AddPlaceCategories
              className="add-place-control__categories"
              title=""
            />
          )}
        </Responsive>
        <Responsive mobile={true}>
          <Overlay
            className="add-place-control__overlay"
            position="bottom"
            dark={isOptionsShown}
            onClick={isOptionsShown ? () => setIsOptionsShown(false) : null}
          >
            {isOptionsShown ? (
              <AddPlaceCategories className="add-place-control__categories" />
            ) : (
              <Button
                className="add-place-control__open-menu-button"
                appearance="primary"
                onClick={() => setIsOptionsShown(true)}
              >
                <Icon
                  className="add-place-control__open-menu-button-icon"
                  name="plus-circle"
                />
                Contribute
              </Button>
            )}
          </Overlay>
        </Responsive>
      </div>
    </>
  );
};

export default AddPlaceControl;
